
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/assets/partnerships/ocrolus",
      function () {
        return require("private-next-pages/docs/assets/partnerships/ocrolus.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/assets/partnerships/ocrolus"])
      });
    }
  